import React from 'react';
import { Target, Lightbulb, TrendingUp, Users } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const goalIcons = [Target, Lightbulb, TrendingUp, Users];

const About = () => {
  const { t } = useLanguage();
  const goals = t('about.goals');

  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-header">
          <span className="section-label">{t('about.label')}</span>
          <h2 className="section-title">{t('about.title')}</h2>
        </div>
        
        <div className="about-content">
          <div className="about-description">
            <p className="body-large">{t('about.description')}</p>
          </div>
          
          <div className="goals-grid">
            {Array.isArray(goals) && goals.map((goal, index) => {
              const IconComponent = goalIcons[index];
              return (
                <div key={index} className="goal-card">
                  <div className="goal-icon">
                    <IconComponent className="w-6 h-6" />
                  </div>
                  <p className="goal-text">{goal}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
